import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "cert-manager-key" }

import { computed } from 'vue';
import { useStore } from 'vuex';
import { useI18n } from '@shell/composables/useI18n';
import CertManagerResourceTabs from '../components/CertManagerResourceTabs.vue';
import Tab from '@shell/components/Tabbed/Tab.vue';
import Banner from '@components/Banner/Banner.vue';
import DetailSummary, { SummaryItem } from '../components/DetailSummary.vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'acme.cert-manager.io.challenge',
  props: {
    value: {}
  },
  setup(__props: any) {

const props = __props;

const { t } = useI18n(useStore());

const details = computed<SummaryItem[]>(() => [
  { label: t('certManager.challenge.presented'), value: props.value.isPresented ? t('generic.yes') : t('generic.no') },
  { label: t('certManager.challenge.processing'), value: props.value.isProcessing ? t('generic.yes') : t('generic.no') },
  { label: t('certManager.challenge.token'), value: props.value.spec?.token },
  {
    label: t('certManager.challenge.url'),
    value: props.value.spec?.url,
    href:  props.value.spec?.url,
  },
  {
    label: t('certManager.challenge.authorizationUrl'),
    value: props.value.spec?.authorizationURL,
    href:  props.value.spec?.authorizationURL,
  },
]);

// `status.reason` is where cert-manager reports why a challenge has not been accepted, so it is
// the first thing an operator needs when ACME issuance is stuck.
const reasonColor = computed(() => (props.value.state === 'error' ? 'error' : 'warning'));

const showReason = computed(() => !!props.value.status?.reason && props.value.state !== 'active');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    (showReason.value)
      ? (_openBlock(), _createBlock(Banner, {
          key: 0,
          color: reasonColor.value,
          label: __props.value.status.reason
        }, null, 8, ["color", "label"]))
      : _createCommentVNode("", true),
    _cache[2] || (_cache[2] = _createTextVNode()),
    _createVNode(CertManagerResourceTabs, { value: __props.value }, {
      default: _withCtx(() => [
        _createVNode(Tab, {
          name: "challenge-details",
          label: _unref(t)('certManager.challenge.tab.details'),
          weight: 30
        }, {
          default: _withCtx(() => [
            _createVNode(DetailSummary, { items: details.value }, null, 8, ["items"]),
            _cache[0] || (_cache[0] = _createTextVNode()),
            _createElementVNode("h3", null, _toDisplayString(_unref(t)('certManager.challenge.key')), 1),
            _cache[1] || (_cache[1] = _createTextVNode()),
            _createElementVNode("pre", _hoisted_1, _toDisplayString(__props.value.spec?.key), 1)
          ]),
          _: 1
        }, 8, ["label"])
      ]),
      _: 1
    }, 8, ["value"])
  ]))
}
}

})